<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "FilterButton"
})
</script>

<template>
    <div class="filter-button" @click="$emit('click')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 4H14" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 4H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 12H12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 12H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 20H16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 20H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2V6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 10V14" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 18V22" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>
            Фільтри
        </div>
    </div>
</template>

<style scoped lang="scss">
.filter-button {
    display: flex;
    cursor: pointer;

    font-family: 'Geist',serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #09090B;
    gap: 2px;
}
</style>
